import '../../polyfills';
import { ConnectorModule, CommonExternalProps, ConnectorExternalProps } from '../../app/connector';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { PromiseWrapper } from '../utils/PromiseWrapper'

require('./definition');

if (require('environment').production) {
  enableProdMode();
}

const connectorProps: ConnectorExternalProps = (<any>window).xprops;
if (connectorProps) {
  connectorProps.getAccessTokenAsync = PromiseWrapper(connectorProps.getAccessTokenAsync);

  const providers: any[] = [
    { provide: ConnectorExternalProps, useValue: connectorProps },
    { provide: CommonExternalProps, useValue: connectorProps },
  ];


  platformBrowserDynamic(providers)
    .bootstrapModule(ConnectorModule);
} else {
  throw new Error("xprops is not found");
}



// WEBPACK FOOTER //
// ./src/xcomponents/connector/index.ts